<template>
  <div v-if="formParams.autoriserUneDedicace">
    <v-checkbox :label="t('LABEL_JE_VEUX_FAIRE_UNE_DEDICACE')" @change="changeDedicace" />
    <template v-if="jeVeuxFaireUneDedicace">
      <div class="mb-6">
        <v-text-field
          id="nomDuDefunt"
          v-model="nomDuDefunt"
          :label="t('LABEL_MEMORIAM')"
          :rules="requiredRules"
          required
          :outlined="isOutlined"
          :dense="isDense"
          style="max-width: 350px"
          @change="updateDedicaceInfo"
        />
      </div>

      <label class="d-block mb-3">{{ t("LABEL_JE_SOUHAITE_AVISER_LA_FAMILLE") }}</label>
      <v-btn-toggle :value="typeCommunication" mandatory tile color="primary accent-3" group class="mb-3">
        <v-btn
          v-for="typeCommunication in typesCommunications"
          :key="typeCommunication.id"
          x-large
          :value="typeCommunication"
          @click="changeTypeCommunication(typeCommunication)"
        >
          {{ typeCommunication.name }}
        </v-btn>
      </v-btn-toggle>
      <template v-if="nePasAviser == false">
        <v-row>
          <v-col cols="12" md="6" class="py-0 pt-3">
            <v-text-field
              v-model="prenom"
              :label="t('LABEL_PRENOM_DEDICACE')"
              :rules="requiredRules"
              required
              :outlined="isOutlined"
              :dense="isDense"
              @change="updateDedicaceInfo"
            />
          </v-col>
          <v-col cols="12" md="6" class="py-0 pt-3">
            <v-text-field
              v-model="nom"
              :label="t('LABEL_NOM_DEDICACE')"
              :rules="requiredRules"
              required
              :outlined="isOutlined"
              :dense="isDense"
              @change="updateDedicaceInfo"
            />
          </v-col>

          <v-col cols="12" md="6" class="py-0">
            <v-text-field
              v-model="courriel"
              :label="t('LABEL_COURRIEL_DEDICACE')"
              type="email"
              :rules="emailRules"
              validate-on-blur
              :outlined="isOutlined"
              :dense="isDense"
              @change="updateDedicaceInfo"
            />
          </v-col>
          <template v-if="aviserParCourrier">
            <v-col cols="12" md="6" class="py-0">
              <v-text-field
                id="adresse-field-dedicace"
                v-model="adresse"
                :label="t('LABEL_ADRESSE_DEDICACE')"
                :rules="requiredRules"
                required
                :outlined="isOutlined"
                :dense="isDense"
                @change="updateDedicaceInfo"
              />
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <v-text-field
                v-model="ville"
                :label="t('LABEL_VILLE_DEDICACE')"
                :rules="requiredRules"
                required
                :outlined="isOutlined"
                :dense="isDense"
                @change="updateDedicaceInfo"
              />
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <v-text-field
                v-model="cp"
                v-mask="zipCodeMask"
                :label="t('LABEL_CODEPOSTAL_DEDICACE')"
                :rules="requiredRules"
                required
                :outlined="isOutlined"
                :dense="isDense"
                @change="updateDedicaceInfo"
              />
            </v-col>

            <v-col cols="12" md="6" class="py-0">
              <v-autocomplete
                v-model="province"
                :label="t('LABEL_PROVINCE_DEDICACE')"
                :items="provinces"
                item-text="name"
                item-value="id"
                clearable
                clear-icon="mdi-close"
                required
                :outlined="isOutlined"
                :dense="isDense"
                @change="updateDedicaceInfo"
              />
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <v-autocomplete
                v-model="pays"
                :label="t('LABEL_PAYS_DEDICACE')"
                :items="countries"
                item-text="name"
                item-value="id"
                :rules="requiredRules"
                required
                :outlined="isOutlined"
                :dense="isDense"
                @change="updateDedicaceInfo"
              />
            </v-col>
          </template>
        </v-row>

        <template v-if="aviserParCourrier" />
      </template>
    </template>
  </div>
</template>

<script>
import { mask } from "vue-the-mask"
import { mapActions, mapGetters } from "vuex"
import masks from "@/config/masks.json"
import PosteCanada from "@/mixins/PosteCanada"

export default {
  mixins: [PosteCanada],
  directives: {
    mask
  },
  components: {},
  data: () => ({
    jeVeuxFaireUneDedicace: false,
    nomDuDefunt: "",
    typeCommunication: null,
    nom: "",
    prenom: "",
    courriel: "",
    adresse: "",
    cp: "",
    ville: "",
    province: null,
    pays: null,
    masksList: null,
    posteCanadaMainconfig: {
      searchFieldId: "adresse-field-dedicace",
      codePostalKey: "cp"
    }
  }),
  watch: {
    aviserParCourrier(newValue) {
      if (newValue) {
        this.setupAddressComplete()
      }
    }
  },
  computed: {
    ...mapGetters([
      "dedicaceInfo",
      "typesDedicaces",
      "typesCommunications",
      "countries",
      "provinces",
      "defaultCountry",
      "defaultProvince",
      "params",
      "formParams",
      "t",
      "isOutlined",
      "isDense"
    ]),
    aviserParCourrier() {
      return this.typeCommunication && this.typeCommunication.code === "POSTE"
    },
    aviserParCourriel() {
      return this.typeCommunication && this.typeCommunication.code === "COURRIEL"
    },
    nePasAviser() {
      return this.typeCommunication && this.typeCommunication.code === "AUCUNE"
    },
    requiredRules() {
      return [(v) => !!v || this.t("CHAMP_REQUIS")]
    },
    emailRules() {
      return [
        (v) => !!v || this.aviserParCourrier || this.nePasAviser || this.t("COURRIEL_REQUIS"),
        (v) => !v || /.+@.+\..+/.test(v) || this.t("COURRIEL_DOIT_ETRE_VALIDE")
      ]
    },
    defaultTypeDedicace() {
      if (this.typesDedicaces.length > 0) {
        return this.typesDedicaces[0]
      }
      return null
    },
    defaultTypeCommunication() {
      if (this.typesCommunications.length > 0) {
        return this.typesCommunications[0]
      }
      return null
    },
    zipCodeMask() {
      if (!this.countryMasks) {
        return "XXXXXXXXXXXX"
      }
      return this.countryMasks.zipCode
    },
    countryData() {
      if (!this.pays) {
        return null
      }
      return this.countries.find((c) => c.id === this.pays)
    },
    countryMasks() {
      if (!this.countryData) {
        return undefined
      }
      return this.masksList[this.countryData.code]
    }
  },
  created() {
    this.province = this.defaultProvince ? this.defaultProvince.id : 0
    this.pays = this.defaultCountry ? this.defaultCountry.id : 0
    this.masksList = masks
  },
  methods: {
    ...mapActions(["setDedicaceInfo", "setJeVeuxFaireUneDedicace"]),
    changeDedicace(value) {
      this.jeVeuxFaireUneDedicace = value
      this.setJeVeuxFaireUneDedicace(this.jeVeuxFaireUneDedicace)
      this.changeTypeCommunication(value === true ? this.defaultTypeCommunication : null)
    },
    changeTypeCommunication(typeCommunication) {
      this.typeCommunication = typeCommunication
      this.updateDedicaceInfo()
    },
    afterPosteCanadaFill() {
      this.updateDedicaceInfo()
    },
    updateDedicaceInfo() {
      const dedicace = {
        nomDuDefunt: this.nomDuDefunt,
        typeCommunication: this.typeCommunication?.id
      }
      let communication = null
      if (!this.nePasAviser) {
        communication = {
          nom: this.nom,
          prenom: this.prenom,
          courriel: this.courriel
        }

        if (this.aviserParCourrier) {
          communication = {
            ...communication,
            adresse: this.adresse,
            cp: this.cp,
            ville: this.ville,
            province: this.province,
            pays: this.pays
          }
        }
      }
      this.setDedicaceInfo({ ...dedicace, ...communication })
    }
  }
}
</script>

<style>
</style>